// Tokens live in httpOnly cookies now — axios sends them via
// withCredentials. Nothing to inject here; Bearer is not used.
export const authInterceptor = (config) => {
  return config;
};
